import crud from './_crud'
import { callApi } from 'utils/api'
import { showErrorMessage, showSuccessMessage } from 'utils/messages'

const actions = crud(
	'trailer_group',
	'el grupo de remolque',
	'los grupos de remolques'
)

const importTrailersGroups = (options) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/trailer_group/import_trailers_groups`, {
			method: 'POST',
			headers: {
				Authorization: state.app.user.token,
			},
			body: JSON.stringify({
				options,
			}),
			successMessage: `Se agreron los grupos de remolques correctamente.`,
		})
		showSuccessMessage('Se registraron los grupos de remolques correctamente')
		return res.body
	}
}

export default { ...actions, importTrailersGroups }
